import React from "react";

export function ModelViewer(props) {
  const { children, src, ...rest } = props;

  return (
    <div className="model-viewer-wrapper">
      <model-viewer src={src} {...rest} ar camera-controls shadow-intensity="0">
        {children}
      </model-viewer>
    </div>
  );
}
